import {
  GetServerSidePropsContext,
  GetServerSidePropsResult,
  Redirect,
} from "next";
import { getSessionCookie, Session } from "./getSessionCookie";

const to_login: Redirect = { destination: "/login", permanent: false };

type CTX = GetServerSidePropsContext;
type Result<T = any> = GetServerSidePropsResult<T>;
type WithSession = CTX & { session: Session };
type CB_WithSession<T = any> = (ctx: WithSession) => Promise<Result<T>>;

export async function withSession<T = any>(
  ctx: CTX,
  cb: CB_WithSession<T>
): Promise<Result<T>> {
  const session = getSessionCookie(ctx.req, ctx.res);
  if (!session) return { redirect: to_login };
  return await cb({ ...ctx, session: session });
}
